// Role ids as returned by the backend in `user.role.id`.
export const ROLES = {
  USER: 1,
  ADMIN: 2,
  MANAGER: 3,
  FREE_ACCESS: 4,
};

// Roles that work with the admin panel instead of the user dashboard.
export const ADMIN_ROLES: number[] = [ROLES.ADMIN, ROLES.MANAGER];
